module.exports = __webpack_public_path__ + "img/email-selected-white.d7adc60c.png";